import { t } from '../i18n'

interface AlertProps {
  type: 'success' | 'error' | 'warning'
  title: string
  text: string
}

export const alertProp = (data: AlertProps) => {
  return {
    type: data.type,
    title: data.title,
    confirmButtonColor: t('swal_color'),
    text: data.text,
  }
}
